import PropTypes from 'prop-types'
import React from 'react'
import styles from './_lineItem.css'
import classnames from 'classnames'

const propTypes = {
  children: PropTypes.node,
  bold: PropTypes.bool,
  className: PropTypes.string,
}

export function LineItem ({ children, bold, className, ...props }) {
  const _className = classnames(styles.container, className, {
    [styles.bold]: bold,
  })

  return (
    <div className={_className} {...props}>
      {children}
    </div>
  )
}

LineItem.propTypes = propTypes

export default LineItem
